import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const RegistrationFilterPanel = ({ filters, onFilterChange, onClearFilters, resultCount }) => {
  const registrationTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'Student', label: 'Student' },
    { value: 'Employer', label: 'Employer' },
    { value: 'Institution', label: 'Institution' }
  ];

  const verificationStatusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Verified', label: 'Verified' },
    { value: 'Rejected', label: 'Rejected' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 sticky top-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-card-foreground">Filters</h3>
        <Button variant="ghost" size="sm" onClick={onClearFilters}>
          Clear All
        </Button>
      </div>

      <div className="mb-4 p-3 bg-primary/10 rounded-lg">
        <p className="text-sm font-medium text-primary">
          {resultCount} registration{resultCount !== 1 ? 's' : ''} found
        </p>
      </div>

      <div className="space-y-6">
        <div>
          <Select
            label="Registration Type"
            options={registrationTypeOptions}
            value={filters?.registrationType}
            onChange={(value) => onFilterChange('registrationType', value)}
          />
        </div>

        <div>
          <Select
            label="Verification Status"
            options={verificationStatusOptions}
            value={filters?.verificationStatus}
            onChange={(value) => onFilterChange('verificationStatus', value)}
          />
        </div>

        <div>
          <label className="text-sm font-medium text-foreground mb-3 block">
            Date Range
          </label>
          <div className="space-y-3">
            <Input
              type="date"
              label="Start Date"
              value={filters?.dateRange?.start}
              onChange={(e) =>
                onFilterChange('dateRange', {
                  ...filters?.dateRange,
                  start: e?.target?.value
                })
              }
            />
            <Input
              type="date"
              label="End Date"
              value={filters?.dateRange?.end}
              onChange={(e) =>
                onFilterChange('dateRange', {
                  ...filters?.dateRange,
                  end: e?.target?.value
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationFilterPanel;